<template>
  <section class="magnify"
     ref="div1"
    @mousemove="move"
    @mouseleave="mOut"
    @mouseenter="mEnter">
    <div  class="image" ref="div2">
      <img 
        v-lazy="{ src: props.srcImage, loading:'', error: require('@/assets/images/loadImage2.png') }"
        alt="تصویر محصول"
        aria-label="تصویر محصول"
        ref="image"
        @load="loadImage"
      />
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted, defineProps, onUpdated ,defineEmits,watch} from "vue";
import {useRoute} from 'vue-router'
const route=useRoute()

// watch for when route changed variables refresh 

watch(() => route.params.name, () => {
  if (div1.value !== null) {
    rect.value = div1.value.getBoundingClientRect();
  }
    movex = 0;
    movey = 0;
});
// scroll use solve rect.value problem 
window.addEventListener('scroll',()=>{
  if(scrollY<400){
    if (div1.value !== null) {
    rect.value = div1.value.getBoundingClientRect();
  }
  }
})

// props to recieve image address 
const props = defineProps({
  srcImage: {
    type: String,
    require: true,
  },
});

// emit for when image loaded, loading in productBody component changed to false
 const emit=defineEmits(['handleImage'])
 const loadImage=()=>{
  emit('handleImage')
 }

const div1 = ref(null);
const div2 = ref(null);
const image = ref(null);
let movex = 0;
let movey = 0;
const rect = ref(null);
// isMouseOverImage is for when user enter div1  change to true and move function work and leeve it set false
let isMouseOverImage = false;

const move = (e) => {
  if (isMouseOverImage && div1.value !== null) {
    movex =
      ((e.clientX - rect.value.left) / div2.value.offsetWidth - 0.5) * 315;
    movey =
      ((e.clientY - rect.value.top) / div2.value.offsetHeight - 0.5) * 430;
    div2.value.style.transform = `translate(${-movex}px, ${-movey}px)`;
    
  }
  
};

const mEnter = () => {
  isMouseOverImage = true;
 
};

const mOut = () => {
  isMouseOverImage = false;
  if (div2.value !== null) {
    div2.value.style.transform = 'translate(0, 0)';
  }
};



onMounted(() => {
  updateRect();
  window.addEventListener("resize", updateRect);
});

onUpdated(() => {
  updateRect();
});

// updateRect for when chenge window size set react value 
const updateRect = () => {
 
  if (div1.value !== null) {
    rect.value = div1.value.getBoundingClientRect();
  }
};
</script>

<style scoped lang="scss">
    .magnify{
      position: relative;
      width: 70%;
      max-width: 70%;
      padding-top: 100%;
      overflow: hidden;
      z-index: 10!important;
  .image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index:20;
    transition: transform 0.2s ease;
    img  {
      width: 100%;
      height: 100%;
      transition: transform 0.2s ease;
      z-index: 20;
    }
  }
  &:hover .image img{
        transform: scale(1.9); /* Add your desired zoom factor here */
        cursor: pointer;
      }
    }

</style>